			(function($) {
				
				// VERTICAL ALIGN FUNCTION
				// $.fn.verticalAlign = function () { /* VERTICAL ALIGN FUNCTION */
				// 	return this
				// 	.css("margin-top",($(this).parent().height() - $(this).height())/2 + 'px' )
				// };

				// // SMOOTH ALL OTHER LINKS THAT AREN'T NAV

				// $('a[href*=#]:not([href=#])').click(function() {
				//   if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
				// 	var target = $(this.hash);
				// 	target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
				// 	if (target.length) {
				// 	  $('html,body').animate({
				// 	    scrollTop: target.offset().top
				// 	  }, 500);
				// 	  return false;
				// 	}
				//   }
				// });
              
				// FLUID VIDEOS FOR RESPONSIVENESS

                fluidvids.init({
                  selector: ['iframe', 'object'], // runs querySelectorAll()
                  players: ['www.youtube.com', 'player.vimeo.com'] // players to support
                });
				
		  
				$(document).ready(function() {

                    //GET RANDOM IMAGES FOR HEADER
				  
					// $('.random-hp-image').pick(1);
                  	// $('.random-sub-image').pick(1);
                    // $('.footer-bg-image').pick(1);

					// $('.newsletter').magnificPopup({
					//   type: 'inline',
					//   preloader: false,
					//   focus: '#name',
					//   callbacks: {
					// 	beforeOpen: function() {
					// 	  if($(window).width() < 700) {
					// 		this.st.focus = false;
					// 	  } else {
					// 		this.st.focus = '#name';
					// 	  }
					// 	}
					//   }
					// });
					
					// TOGGLE
					$(".starter").click(function(){
						$("#toggle").slideToggle();
						if ($(this).find('span').hasClass('glyphicon-menu-up')){
							$('html,body').animate({
								scrollTop: $("#toggle").offset().top
							}, 500, 'easeInOutExpo');
							$(this).find('span').removeClass('glyphicon-menu-up').addClass('glyphicon-menu-down');
						}
						else {
							$(this).find('span').removeClass('glyphicon-menu-down').addClass('glyphicon-menu-up');
						}
					});

					// FAQ TOGGLE
                    $('.accordion > ul > li').click(function() {
                      $(this).toggleClass('ui-open').find('ul').slideToggle();
                    });

					// SLIDER THUMBNAIL CLASS ADD
					$(".slider-thumbnails a").click(function(){
                      $(".slider-thumbnails a").removeClass('current');
					  $(this).addClass('current');
					});

                });

				$('.bxslider-header').bxSlider({
					auto: true,
					pager: false
				});


				//NIVO SLIDER
				
				// $(window).load(function() {
				// 	$('#slider').nivoSlider({
				// 				effect: 'sliceUpDownRight',                 
				// 				slices: 24,                    // For slice animations
				// 				boxCols: 12,                     // For box animations
				// 				boxRows: 12,                     // For box animations
				// 				animSpeed: 600,                // Slide transition speed
				// 				pauseTime: 12000,                    
				// 				directionNav: false,              
				// 				controlNav: false,                 
				// 				prevText: '',                  
				// 				nextText: ''
				// 	});
				// });

				var jRes = jRespond([
					{
						label: 'handheld',
						enter: 0,
						exit: 767
					},{
						label: 'tablet',
						enter: 768,
						exit: 992
					},{
						label: 'laptop',
						enter: 993,
						exit: 1199
					},{
						label: 'desktop',
						enter: 1200,
						exit: 10000
					}
				]);
			
				jRes.addFunc([
					{
						breakpoint: ['desktop','laptop','tablet'],
						enter: function() {

                          // VERTICAL ALIGN
                          $('.vertalign').each(function() {
                              $( this ).verticalAlign();
                          });

                          //EQUALHEIGHTS
                          $('.sameheight').equalHeightColumns();
                          $('.sameheight-footer').equalHeightColumns();

                        },
						exit: function() {
                          $('.sameheight,.sameheight-footer').css('min-height','auto');
                        }
					},{
						breakpoint: ['handheld'],
						enter: function() {
                          
                          /* ANIMATE THE HOMEPAGE FOR MOBILE ONLY */
                          $('.hp-nav-wrap h1').delay(1500).fadeIn(2000);
                          $('.hp-nav-wrap h1 span').delay(2500).fadeIn(2000);

                          setTimeout(function(){
                            var $parent = $('#header-main-nav');
                            // Get the offset alone
                            var offset = $parent.offset().top;
                              // If the offset is less than the scroll position
                              if (offset == ($(window).scrollTop() + $(window).height())) {
                                  $('html, body').animate({
                                                // reuse your 'offset' variable instead of calculating it again
                                      scrollTop: offset
                                  }, 1500);
                              }
                            }, 5000);
                          
                          /* SIMPLE TOGGLE ACTION */
							$('.mobile-toggle-view').click(function () {
						
								var text = $(this).next('.mobile-panel');
						
								if (text.is(':hidden')) {
									text.slideDown('200');
									$(this).addClass('mobile-toggle-open');
								} else {
									text.slideUp('200');
									$(this).removeClass('mobile-toggle-open');
								}
								
							});
                          
                          /* ADJUST VH FOR MOBILE */
                          var bg = jQuery(".random-hp-image");
                          function resizeBackground() {
                              bg.height(jQuery(window).height());
                          }
                          jQuery(window).resize(resizeBackground());
                          resizeBackground();

                        },
						exit: function() {}
					},{
					}
				]);
				
				
			})(jQuery);